import { Arrays, assert, panic, UUID } from "@opendaw/lib-std";
import { Pointers } from "@opendaw/studio-enums";
import { TrackType } from "./timeline/TrackType";
import { DeviceBoxUtils } from "./DeviceBox";
export var DeviceAccepts;
(function (DeviceAccepts) {
    DeviceAccepts.toTrackType = (type) => {
        switch (type) {
            case "midi":
                return TrackType.Notes;
            case "audio":
                return TrackType.Audio;
            default:
                return panic();
        }
    };
})(DeviceAccepts || (DeviceAccepts = {}));
export var DeviceHost;
(function (DeviceHost) {
    // The chain collection a host keeps for effects of `accepts`, or `None` when it hosts no such chain.
    DeviceHost.chainOf = (host, accepts) => accepts === "audio" ? host.audioEffects : host.midiEffects;
    // The chain HOST FIELD an effect of `accepts` attaches to, or `None` when the host takes no such chain.
    DeviceHost.chainFieldOf = (host, accepts) => accepts === "audio" ? host.audioEffectsField : host.midiEffectsField;
    // Whether an effect of `accepts` may be inserted into this host. The host must hold a chain of that kind
    // at all; a MIDI effect additionally requires a note CONSUMER, so an instrument-hosting host must have an
    // instrument that takes notes. A composite entry hosts no instrument — its notes flow on to whatever
    // consumes them downstream — so there the chain's presence alone decides.
    DeviceHost.takesEffect = (host, accepts) => DeviceHost.chainFieldOf(host, accepts).nonEmpty()
        && (accepts === "audio" || !host.hostsInstrument
            || host.inputAdapter.mapOr(input => input.accepts === "midi", false));
})(DeviceHost || (DeviceHost = {}));
export var Devices;
(function (Devices) {
    Devices.isAny = (adapter) => adapter !== null && typeof adapter === "object" && "type" in adapter
        && (adapter.type === "midi-effect" || adapter.type === "bus"
            || adapter.type === "instrument" || adapter.type === "audio-effect");
    Devices.isEffect = (adapter) => adapter !== null && typeof adapter === "object" && "type" in adapter
        && (adapter.type === "midi-effect" || adapter.type === "audio-effect");
    Devices.isInstrument = (adapter) => adapter !== null && typeof adapter === "object" && "type" in adapter && adapter.type === "instrument";
    Devices.isMidiEffect = (adapter) => adapter !== null && typeof adapter === "object" && "type" in adapter && adapter.type === "midi-effect";
    Devices.isAudioEffect = (adapter) => adapter !== null && typeof adapter === "object" && "type" in adapter && adapter.type === "audio-effect";
    Devices.isHost = (value) => value !== null && typeof value === "object" && "class" in value && value.class === "device-host";
    Devices.deleteEffectDevices = (devices) => {
        if (devices.length === 0) {
            return;
        }
        assert(Arrays.satisfy(devices, (a, b) => a.deviceHost().address.equals(b.deviceHost().address)), "Devices are not connected to the same host");
        const device = devices[0];
        const field = DeviceHost.chainFieldOf(device.deviceHost(), device.accepts)
            .unwrap(`host takes no ${device.accepts} effects`);
        const targets = field.pointerHub.filter(device.accepts === "audio"
            ? Pointers.AudioEffectHost
            : Pointers.MIDIEffectHost);
        targets.map(({ box }) => DeviceBoxUtils.lookupIndexField(box))
            .filter(index => devices.some(device => UUID.Comparator(device.uuid, index.address.uuid) !== 0))
            .sort((a, b) => a.getValue() - b.getValue())
            .forEach((indexField, index) => indexField.setValue(index));
        devices.forEach(device => device.box.delete());
    };
})(Devices || (Devices = {}));
